import React, { useState, useEffect } from "react";
import { Button, Form, Divider, Typography, message, Input } from "antd";
import strings from "../utils/Localization";
import { useHistory, useLocation } from "react-router-dom";
import { Layout } from "../components/sifremiUnuttum";
import { api } from "../helpers/ApiHelper";
const { Paragraph } = Typography;

const paragraphStyle = { textAlign: "center", letterSpacing: 1 };

function SifremiUnuttumKodDogrulama() {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [form] = Form.useForm();
  const history = useHistory();
  const { state } = useLocation();
  const { slogan, kodOnayButon, dogrulamaKodu, dogrulamaKoduPlaceHolder } =
    strings.sifremiUnuttumKodDogrulama;

  useEffect(() => {
    //state === undefined && history.push("/SifremiUnuttumMailDogrulama");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onFinish = async (values) => {
    try {
      const { code } = values;
      setFetchLoading(true);
      const response = await api.post("/auth/sifreunuttumdogrulama", {
        Email: state.eMail,
        DogrulamaKodu: code,
      });
      if (response.status === 200) {
        history.push({
          pathname: "/SifremiUnuttumYeniSifre",
          state: {
            eMail: state.eMail,
            code: code,
          },
        });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Layout>
      <Paragraph style={paragraphStyle}>{slogan}</Paragraph>
      <Divider />
      <Form
        form={form}
        layout="vertical"
        size="large"
        name="basic"
        onFinish={onFinish}
      >
        <Form.Item
          label={dogrulamaKodu}
          name="code"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input placeholder={dogrulamaKoduPlaceHolder} autoFocus />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            size="large"
            loading={fetchLoading}
          >
            {kodOnayButon}
          </Button>
        </Form.Item>
      </Form>
    </Layout>
  );
}

export default SifremiUnuttumKodDogrulama;
